import { gql, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { useSessionContext } from 'src/contexts';
import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';

export const SUPPORT_TOKENS_VALIDATION = gql`
  query ($memberToken: String!, $supporterToken: String!, $supportRequestId: ObjectId!) {
    supportTokensValidation(
      memberToken: $memberToken
      supporterToken: $supporterToken
      supportRequestId: $supportRequestId
    )
  }
`;

export const useSupportAuth = () => {
  const query = useRouteQuery();
  const navigate = useNavigate();
  const memberToken = query.get('memberToken');
  const supporterToken = query.get('supporterToken');
  const supportRequestId = query.get('supportRequestId');
  const [session, updateSessionContext] = useSessionContext();

  const { data } = useQuery(SUPPORT_TOKENS_VALIDATION, {
    variables: { memberToken, supporterToken, supportRequestId },
    skip: !memberToken || !supporterToken || !supportRequestId,
    fetchPolicy: 'network-only',
  });

  const tokensValid = !!data?.supportTokensValidation;

  if (tokensValid) {
    updateSessionContext({
      ...session,
      accessToken: memberToken as string,
      isAuthenticated: true,
      redirectPath: ROUTES.dashboard,
    });

    navigate(ROUTES.dashboard);
  }
};
